module.exports = __webpack_public_path__ + "media/images/defaults/featured_content_image/thumb-ed49a61fb211fcc0eacbf9fdf06ea5f0.png";